import { ICellEditorParams } from "@ag-grid-community/core";
import { Box, Checkbox, Stack, Text, useCheckboxGroup } from "@chakra-ui/react";
import React from "react";
import {
  IRegistryChoiceOptions,
  IRegistryDataColumn,
} from "../../../models/RegistryDataColumn";

export const EditorCheckbox = React.forwardRef(
  (props: ICellEditorParams, ref) => {
    const inputRef = React.useRef<any>();
    const [checkboxOptions, setCheckboxOptions] =
      React.useState<IRegistryChoiceOptions>();

    const {
      value,
      getCheckboxProps,
      setValue: setValueCheckbox,
    } = useCheckboxGroup({
      defaultValue: [],
    });

    React.useImperativeHandle(ref, () => {
      return {
        getValue: () => {
          const activeCheckboxLabels: string[] = [];
          const updateData = {};

          // Update lookup key
          if (checkboxOptions) {
            Object.entries(checkboxOptions).forEach(([key, option]) => {
              let newTargetValue = 0;

              if (value.includes(option.value)) {
                activeCheckboxLabels.push(option.label);
                newTargetValue = 1;
              }
              updateData[option.lookup_key as string] = newTargetValue;
            });
          }

          let activeLabels = activeCheckboxLabels.join(", ");

          return activeLabels;
        },

        afterGuiAttached: () => {
          // setValue(props.value);
          inputRef.current.focus();
          inputRef.current.select();
        },
      };
    });

    React.useEffect(() => {
      const defaultValueUpdate: any[] = [];
      const colData = props.data;
      const colDef = props.colDef as any;
      const colMeta = colDef.meta as IRegistryDataColumn;

      const checkboxOptions = colMeta.options;

      if (checkboxOptions) {
        Object.entries(checkboxOptions).forEach(([key_val, option], idx) => {
          if (option && option.lookup_key) {
            const lookupValueOnRecord = colData[option.lookup_key];

            try {
              if (`${lookupValueOnRecord}` === "1") {
                defaultValueUpdate.push(option.value);
              }
            } catch (e) {}
          }
        });
      }

      setCheckboxOptions(checkboxOptions);
      setValueCheckbox(defaultValueUpdate);
      // eslint-disable-next-line
    }, [props.data, props.colDef]);

    return (
      <Box p={4}>
        <Stack spacing={4} px={4}>
          {checkboxOptions &&
            Object.entries(checkboxOptions).map(([key, option]) => (
              <Checkbox
                role={"group"}
                key={option.lookup_key}
                {...getCheckboxProps({ value: option.value })}
              >
                <Text _groupHover={{ opacity: ".8" }}>{option.label}</Text>
              </Checkbox>
            ))}
        </Stack>
      </Box>
    );
  }
);
